import { render, staticRenderFns } from "./Classify.vue?vue&type=template&id=412511d1&scoped=true&"
import script from "./Classify.vue?vue&type=script&lang=js&"
export * from "./Classify.vue?vue&type=script&lang=js&"
import style0 from "./Classify.vue?vue&type=style&index=0&id=412511d1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412511d1",
  null
  
)

export default component.exports